export class NotificationPaths {
    public static audit: string = 'notification/audit';
    public static customMessagingConfiguration: string = 'notification/custom-messaging-configuration'
    public static customerNotificationConfig: string = 'notification/customer-notification-config';
    public static file: string = 'notification/file';
    public static notificationConfig: string = 'notification/notification-config';
    public static notification: string = 'notification/notification';
}
